var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5049 8.45893L19.404 8.0308H10.0987V11.9692H15.6585C15.0812 14.7103 12.4027 16.1531 10.2147 16.1531C8.62277 16.1531 6.94464 15.4835 5.83393 14.4071C5.24791 13.8302 4.78145 13.1433 4.46125 12.3859C4.14104 11.6284 3.97338 10.8152 3.96786 9.99286C3.96786 8.33393 4.71339 6.67455 5.79821 5.58304C6.88304 4.49152 8.52143 3.8808 10.1504 3.8808C12.0161 3.8808 13.3531 4.87143 13.8531 5.32321L16.6518 2.53929C15.8308 1.81786 13.5754 0 10.0603 0C7.34821 0 4.74777 1.03884 2.84687 2.93348C0.970982 4.79911 0 7.49688 0 10C0 12.5031 0.91875 15.0661 2.73661 16.9464C4.67902 18.9518 7.42991 20 10.2625 20C12.8397 20 15.2826 18.9902 17.0237 17.158C18.7353 15.3545 19.6205 12.8589 19.6205 10.2429C19.6205 9.14152 19.5098 8.4875 19.5049 8.45893Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.dd947617956938a0b3df15039c423fb1.svg";
export { ForwardRef as ReactComponent };